import CreateProjectsContainer from "../containers/CreateProjectsContainer";

const CreateProjectsPage = () => {
  return (
    <CreateProjectsContainer />
  );
};

export default CreateProjectsPage;
